/** Public paths for the live landing (served from dashboard/public). */
export const LANDING_ASSETS = {
  logo: '/brand/landing/linas-logo.svg',
  appIcon: '/brand/landing/linas-app-icon.svg',
  /**
   * In-phone How it works screens — all 780×1688, sharp admin UI only.
   */
  howItWorksScreens: {
    ownerCopilot: '/brand/landing/app-screens/screens/01-owner-copilot-screen.png',
    sideMenu: '/brand/landing/app-screens/screens/02-side-menu-screen.png',
    dashboard: '/brand/landing/app-screens/screens/03-dashboard-screen.png',
    aiSetup: '/brand/landing/app-screens/screens/04-ai-setup-screen.png',
    smartAnswers: '/brand/landing/app-screens/screens/05-smart-answers-screen.png',
    smartFollowUp: '/brand/landing/app-screens/screens/06-smart-follow-up-screen.png',
    integrations: '/brand/landing/app-screens/screens/07-integrations-screen.png',
    liveChat: '/brand/landing/app-screens/screens/08-live-chat-screen.png',
    requests: '/brand/landing/app-screens/screens/09-requests-screen.png',
    users: '/brand/landing/app-screens/screens/10-users-screen.png',
    subscription: '/brand/landing/app-screens/screens/11-subscription-screen.png',
    settings: '/brand/landing/app-screens/screens/13-settings-screen.png',
  },
};

/** Design tokens from LINAS_AI_LANDING_PAGE_DESIGN brand SVGs / screenshots. */
export const LANDING_THEME = {
  green: '#06715F',
  greenDeep: '#0B3D34',
  mint: '#54C7AC',
  ink: '#171A19',
  muted: '#5C6663',
  line: '#E4E8E6',
  surface: '#F6F7F6',
  white: '#FFFFFF',
  black: '#0B0D0C',
};
